import React from "react";

const useOutsideClick = <T extends HTMLElement>(callback: () => void) => {
	const ref = React.useRef<T>(null);

	React.useEffect(() => {
		const handleClick = (event: MouseEvent) => {
			if (ref.current && !ref.current.contains(event.target as Node)) {
				callback();
			}
		};

		document.addEventListener("click", handleClick, true);

		return () => {
			document.removeEventListener("click", handleClick, true);
		};
	}, [ref]);

	return ref;
};

export default useOutsideClick;
